import React, { useState } from 'react';
import './Blog1.css'
import fahim from '../../images/blog-image/fahim.jpg'
import { BsFacebook, BsLinkedin, BsInstagram, BsGithub, BsFileEarmarkPdf } from 'react-icons/bs';
import { FaXTwitter } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import npm1 from '../../images/blog-image/npm1.jpeg'
import npm from '../../images/blog-image/npm.png'
import visa from '../../images/blog-image/visa.jpg'
import program from '../../images/blog-image/study-program.jpg'
import useTitle from '../../Hooks/useTitle';
import studyAbroad from '../../images/blog-image/study-abroad.jpg'


import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/default-highlight';
import { nightOwl } from 'react-syntax-highlighter/dist/cjs/styles/hljs';
import { sunburst } from 'react-syntax-highlighter/dist/cjs/styles/hljs';
import copy from 'clipboard-copy';





import {
    TwitterShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    TwitterIcon,
    FacebookIcon,
    LinkedinIcon,
    WhatsappIcon,
} from "react-share";





import ReactPrint from 'react-to-print';
import { useRef } from 'react';





import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import ReactToPrint from 'react-to-print';
import { useLanguage } from '../../context/LanguageContext';
// import  { Pagination, Navigation, Autoplay } from "swiper";


SwiperCore.use([Autoplay, Pagination]);






















const Blog6Details = () => {


    const shareUrl = window.location.href
    // console.log('Current Window Location: ', window.location)
    // console.log('Current Page URL: ', window.location.href)
    // console.log('Path Name: ', window.location.pathname)

    const { language } = useLanguage()

    const ref = useRef();

    window.scrollTo(0, 0);
    useTitle('Blog-Some Tips For Writing Good Comments In Your Code');

    const postUrl = `https://fahim-faysal-portfolio.netlify.app/blog1`;
    const postTitle = 'Tips For Writing Comments In Your Code';
    const shareOnTwitter = () => {
        window.open(`https://twitter.com/intent/tweet?text=${postTitle}&url=${postUrl}`, '_blank');
    };
    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${postUrl}`, '_blank');
    };
    const shareOnLinkedIn = () => {
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${postUrl}&title=${postTitle}`, '_blank');
    };
    <Helmet>
        <title>{postTitle}</title>
        <meta property="og:title" content={postTitle} />
        <meta property="og:image" content={visa} />
        <meta property="og:url" content={`https://fahim-faysal-portfolio.netlify.app/blog1`} />
    </Helmet>










    return (
        <div className=' mt-12 lg:px-2 md:px-2 px-0 '>


            <div className='flex justify-center lg:flex-row flex-col mb-20 lg:px-0 md:px-8 px-2 lg:gap-x-3 lg:gap-y-0 gap-x-4 gap-y-20'>



                <div className=' print:hidden lg:block hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1  md:left-0 fixed top-[160px]'>
                    <div className=''>
                        <div className={`bg-base-100 border-r-4 border-gray-600   rounded-lg }`}>
                            <div className="avatar flex justify-center items-center">
                                <div className="mt-2  w-[105px] rounded-full">
                                    <img className='mx-auto' src={fahim} alt='fahim' />
                                </div>
                            </div>
                            <p className='-mt-1 text-white text-2xl font-bold text-center px-6 py-3'>FAHIM FAYSAL</p>
                            <p className='-mt-1 text-[16px] text-justify px-4'>I am a full-stack developer from Bangladesh and am available to work in office or remotely.</p>
                            <p className='mt-3 text-[16px] text-amber-500 text-justify px-4'>Expert In: <span className='text-white'>ReactJS, NodeJS, MongoDB, Redux, Firebase</span></p>
                            <div className='flex justify-center items-center gap-x-4 mt-4'>
                                <div className=''>
                                    <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip' data-tip='GitHub'>
                                        <BsGithub className='text-white text-2xl my-2 hover:bg-black hover:text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip' data-tip='LinkedIn'>
                                        <BsLinkedin className='text-white text-2xl my-2 hover:text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
                                    </a>
                                </div>
                                <div className=' '>
                                    <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip' data-tip='Instagram'>
                                        <BsInstagram className='text-white text-2xl my-2 hover:text-rose-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip' data-tip='Facebook'>
                                        <BsFacebook className='text-white text-2xl my-2 hover:text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
                                    </a>
                                </div>
                            </div>
                            <Link to='/contact'>
                                <div className='w-full mt-3 mx-auto text-center cursor-pointer'>
                                    <button className=' text-lg w-full px-16 py-2 bg-rose-700 hover:bg-rose-800 rounded-sm text-white'>Hire Me</button>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>













                <div className='lg:ml-[355px] lg:w-6/12 w-full mx-auto bg-white screen:shadow-2xl print:shadow-none md:px-6 px-2 py-8 ml:0'>

                    <div>
                        <div ref={ref} className='bg-white text-black mt-6'>
                            <div>

                                {
                                    language === 'english' ?
                                        <div>
                                            <div>
                                                <h2 className='font-sans lg:text-[33px] md:text-[36px] text-[26px] text-start font-bold text-black mb-10 '>Some Tips For Writing Good Comments In Your Code</h2>
                                            </div>
                                            <div>
                                                <h2 className='mt-12 font-mono lg:text-3xl md:text-3xl text-2xl text-start font-bold text-black mb-3'>What are code comments?</h2>
                                                <p className=' text-justify  text-gray-800 font-serif  text-[19px]'> In computer programming, comments in code are used to include information on portions of source code in a project. Code comments are intended to make the related code easier to understand by providing additional context or explanation.</p>
                                            </div>
                                            <div>
                                                <h2 className='mt-6 font-mono lg:text-3xl md:3xl text-2xl text-start font-bold text-black mb-3'>Why Use Code Comments?</h2>
                                                <p className='mb-3 text-justify text-gray-800 font-serif  text-[19px]'>⦿ Code Comments used to document the design and functionality of a program and to provide instructions for how to use or modify a piece of code. They can also be used to indicate potential issues or areas of the code that require attention.</p>
                                                <p className='mb-3 text-justify px-2 text-gray-800 font-serif  text-[19px]'>⦿ Code Comments add to source code using a special syntax, which varies depending on the programming language in question. In many languages, comments are denoted by a specific character or sequence of characters (e.g. `//` or #).</p>
                                                <p className='mb-3 text-justify px-2 text-gray-800 font-serif  text-[19px]'>⦿ In the dev community, code comments are controversial. Some disown the practice altogether, claiming comments actually make code worse, while others maintain it as a necessary element of professional programming.</p>
                                                <p className='mb-3 text-justify px-2 text-gray-800 font-serif  text-[19px]'>⦿ Regardless of which bucket you fall in, understanding code comments best practices will serve you well in a career as a professional software developer and will make you a more appealing project collaborator.</p>
                                            </div>
                                            <div>
                                                <h2 className='mt-10 font-mono lg:text-3xl md:3xl text-2xl text-start font-bold text-black mb-3'>Some Best Practices For Code Comments</h2>
                                                <p className='  text-justify  text-gray-800 font-serif  text-[19px]'>A good best practice to follow when writing comments in code is to describe the why, not the what. In general, good code should be self-explanatory in how it works, at least in isolation. Explain the reasoning behind the code, not just what the code is doing. This can help others understand the intent of the code.</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-6 text-xl font-bold text-start mb-2 text-gray-800'>Make comments meaningful</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>Comments should not duplicate the code. It would be silly if a code’s corresponding comment just copied the code itself. Comments should add useful context, information, explanation, etc. Avoid writing comments that simply repeat the code or state the obvious.</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>Comment on your classes, methods, and functions</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>Include brief descriptions of classes, methods, and functions so others can understand the purpose of these items in the codebase. These are great cases for using comments. They explain the class or function in isolation, and are found where they are needed – next to the code they are explaining.</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>Use clear and concise language</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>Comments should be written in clear and concise language. Avoid using jargon, slang, or complex vocabulary. Avoid personal notes, remarks, or jokes. Generally, a good rule of thumb when it comes to code comments is: less is more.</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>Be consistent with your commenting style</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>Establish a commenting style for your code comments with you and your team and be consistent with it. In most cases, code is divided into levels like chunks, functions, modules, libraries, etc. It’s best to develop a specific commenting style for each level and stay consistent.</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>Include reference links when relevant</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>If you use code that you found online or unidiomatic code, include a link reference to the source in a code comment to help future readers. Similarly, if there is an external source that provides helpful context for your code, include a link in a comment.</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>Write comments at the same time you’re writing the code.</h1>
                                                <p className='text-justify text-gray-800 font-serif  text-[19px]'>Depending on the complexity of the code in question, there may be weeks between when you start and finish your task at hand, and in that time, you can forget why you made some of the decisions you did when writing the code. Some developers actually suggest writing your comments before you write the code and letting it guide you.</p>
                                            </div>
                                            <div>
                                                <h2 className='mt-10 font-mono lg:text-3xl md:3xl text-2xl text-start font-bold text-black mb-3'>Things to avoid when writing code comments</h2>
                                                <p className='mt-5  text-justify  text-gray-800 font-serif  text-[19px]'>One of the most important things to keep in mind concerning code comments: incorrect information is worse than no information at all. Comments should dispel confusion, not cause it. <br />  You should understand the limitations of comments. Trying to explain flows across multiple source files or repositories; using comments is liable to be more confusing than helpful. There are better ways to explain these flows, as we will describe later. <br /> Comments in code should always be kept up to date. They should accurately reflect the current state of the code in question. If you make changes to a portion of code in a project, you should update the comment accordingly.</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-6 text-xl font-bold text-start mb-2 text-gray-800'>Don’t leave “To-Do” comments</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>Use work management systems for this. If you’re pushing a TODO, you should be creating an issue instead. Otherwise, you’re just generating technical debt.</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>Don’t write comments in the wrong place.</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'> Add your code comments in a logical location within the code, and keep your practice consistent. This makes it easier to find comments when you need them.</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>Don’t comment out code</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'> Instead of commenting out code, it’s better to use a version control system, such as Git, to track your code changes.</p>
                                            </div>
                                            <div className='mb-16'>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>Don’t over-comment.</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>Too many comments can make code harder to read and understand. Only add comments when necessary, not to every line of code. Avoid redundant comments.</p>
                                            </div>
                                        </div>
                                        :

                                        <div>
                                            <div>
                                                <h2 className='font-sans lg:text-[32px] md:text-[32px] text-[24px] text-justify font-bold text-black mb-10 '>আপনার কোডে ভালো মন্তব্য লেখার জন্য কিছু টিপস</h2>
                                            </div>
                                            <div>
                                                <h2 className='mt-12 font-mono lg:text-2xl md:2xl text-2xl text-start font-bold text-black mb-3'>কোড মন্তব্য কি?</h2>
                                                <p className=' text-justify  text-gray-800 font-serif  text-[19px]'> কম্পিউটার প্রোগ্রামিংয়ে, কোডের মন্তব্যগুলি একটি প্রকল্পে সোর্স কোডের অংশগুলির তথ্য অন্তর্ভুক্ত করতে ব্যবহৃত হয়। কোড মন্তব্য অতিরিক্ত প্রসঙ্গ বা ব্যাখ্যা প্রদান করে সম্পর্কিত কোড বোঝা সহজ করার উদ্দেশ্যে করা হয়</p>
                                            </div>
                                            <div>
                                                <h2 className='mt-6 font-mono lg:text-2xl md:2xl text-2xl text-start font-bold text-black mb-3'>কেন আপনি কোড মন্তব্য ব্যবহার করবেন?</h2>
                                                <p className='mb-3 text-justify text-gray-800 font-serif  text-[19px]'>⦿ কোড মন্তব্যগুলি একটি প্রোগ্রামের নকশা এবং কার্যকারিতা নথিভুক্ত করতে এবং কোডের একটি অংশ কীভাবে ব্যবহার বা সংশোধন করতে হয় তার নির্দেশাবলী প্রদান করতে ব্যবহৃত হয়। এগুলি সম্ভাব্য সমস্যা বা কোডের ক্ষেত্রগুলি নির্দেশ করতেও ব্যবহার করা যেতে পারে যেগুলির জন্য মনোযোগ প্রয়োজন৷</p>
                                                <p className='mb-3 text-justify px-2 text-gray-800 font-serif  text-[19px]'>⦿ কোড মন্তব্য একটি বিশেষ সিনট্যাক্স ব্যবহার করে সোর্স কোডে যোগ করে, যা প্রশ্নে থাকা প্রোগ্রামিং ভাষার উপর নির্ভর করে পরিবর্তিত হয়। অনেক ভাষায়, মন্তব্যগুলি একটি নির্দিষ্ট অক্ষর বা অক্ষরের ক্রম দ্বারা চিহ্নিত করা হয় (যেমন `//` বা #)</p>
                                                <p className='mb-3 text-justify px-2 text-gray-800 font-serif  text-[19px]'>⦿ দেব সম্প্রদায়ে, কোড মন্তব্যগুলি বিতর্কিত। কেউ কেউ অনুশীলনটিকে পুরোপুরি অস্বীকার করে, দাবি করে মন্তব্যগুলি আসলে কোডকে আরও খারাপ করে তোলে, অন্যরা এটিকে পেশাদার প্রোগ্রামিংয়ের একটি প্রয়োজনীয় উপাদান হিসাবে বজায় রাখে।</p>
                                                <p className='mb-3 text-justify px-2 text-gray-800 font-serif  text-[19px]'>⦿ আপনি যে বালতিতে পড়েন তা নির্বিশেষে, কোড মন্তব্যগুলি বোঝার সেরা অনুশীলনগুলি আপনাকে একজন পেশাদার সফ্টওয়্যার বিকাশকারী হিসাবে ক্যারিয়ারে ভালভাবে কাজ করবে এবং আপনাকে আরও আকর্ষণীয় প্রকল্প সহযোগী করে তুলবে।</p>
                                            </div>
                                            <div>
                                                <h2 className='mt-10 font-mono lg:text-2xl md:2xl text-2xl text-start font-bold text-black mb-3'>কোড মন্তব্যের জন্য কিছু সেরা অভ্যাস</h2>
                                                <p className='  text-justify  text-gray-800 font-serif  text-[19px]'>কোডে মন্তব্য লেখার সময় অনুসরণ করার একটি ভাল সর্বোত্তম অনুশীলন হল কেন বর্ণনা করা, কী নয়। সাধারণভাবে, ভাল কোডটি কীভাবে কাজ করে তাতে স্ব-ব্যাখ্যামূলক হওয়া উচিত, অন্তত বিচ্ছিন্নভাবে। কোডের পিছনে যুক্তি ব্যাখ্যা করুন, কোডটি কী করছে তা নয়। এটি অন্যদের কোডের উদ্দেশ্য বুঝতে সাহায্য করতে পারে।</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-6 text-xl font-bold text-start mb-2 text-gray-800'>মন্তব্য অর্থপূর্ণ করুন</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>মন্তব্য কোড নকল করা উচিত নয়. এটি মূর্খ হবে যদি একটি কোডের সংশ্লিষ্ট মন্তব্য শুধুমাত্র কোডটি নিজেই অনুলিপি করে। মন্তব্যে দরকারী প্রসঙ্গ, তথ্য, ব্যাখ্যা, ইত্যাদি যোগ করা উচিত। এমন মন্তব্য লেখা এড়িয়ে চলুন যা কেবল কোডের পুনরাবৃত্তি করে বা স্পষ্টভাবে উল্লেখ করে।</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>আপনার Class, Method এবং Function সম্পর্কে মন্তব্য করুন</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>ক্লাস, পদ্ধতি এবং ফাংশনের সংক্ষিপ্ত বিবরণ অন্তর্ভুক্ত করুন যাতে অন্যরা কোডবেসে এই আইটেমগুলির উদ্দেশ্য বুঝতে পারে। এই মন্তব্য ব্যবহার করার জন্য মহান ক্ষেত্রে. তারা ক্লাস বা ফাংশনকে বিচ্ছিন্নভাবে ব্যাখ্যা করে, এবং যেখানে তাদের প্রয়োজন সেখানে পাওয়া যায় - তারা যে কোডটি ব্যাখ্যা করছে তার পাশে। </p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>পরিষ্কার এবং সংক্ষিপ্ত ভাষা ব্যবহার করুন</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>মন্তব্য স্পষ্ট ও সংক্ষিপ্ত ভাষায় লিখতে হবে। জার্গন, স্ল্যাং বা জটিল শব্দভান্ডার ব্যবহার করা এড়িয়ে চলুন। ব্যক্তিগত নোট, মন্তব্য, বা কৌতুক এড়িয়ে চলুন. সাধারণত, কোড মন্তব্যের ক্ষেত্রে একটি ভাল নিয়ম হল: কম বেশি।</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>আপনার মন্তব্য শৈলী সঙ্গে সামঞ্জস্যপূর্ণ হন</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>আপনার এবং আপনার দলের সাথে আপনার কোড মন্তব্যের জন্য একটি মন্তব্য শৈলী স্থাপন করুন এবং এটির সাথে সামঞ্জস্যপূর্ণ হন। বেশিরভাগ ক্ষেত্রে, কোডকে ভাগ করা হয় লেভেলে ভাগ করা হয় যেমন খণ্ড, ফাংশন, মডিউল, লাইব্রেরি, ইত্যাদি। প্রতিটি স্তরের জন্য একটি নির্দিষ্ট মন্তব্য করার স্টাইল তৈরি করা এবং সামঞ্জস্যপূর্ণ থাকা ভাল।</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>প্রাসঙ্গিক হলে রেফারেন্স লিঙ্ক অন্তর্ভুক্ত করুন</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>আপনি যদি অনলাইনে বা ইউনিডিওমেটিক কোড পাওয়া কোড ব্যবহার করেন, তাহলে ভবিষ্যৎ পাঠকদের সাহায্য করার জন্য একটি কোড মন্তব্যে উৎসের একটি লিঙ্ক উল্লেখ করুন। একইভাবে, যদি কোনও বাহ্যিক উত্স থাকে যা আপনার কোডের জন্য সহায়ক প্রসঙ্গ সরবরাহ করে, একটি মন্তব্যে একটি লিঙ্ক অন্তর্ভুক্ত করুন।</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>আপনি কোড লিখছেন একই সময়ে মন্তব্য লিখুন</h1>
                                                <p className='text-justify text-gray-800 font-serif  text-[19px]'>প্রশ্নে থাকা কোডের জটিলতার উপর নির্ভর করে, আপনি যখন আপনার কাজটি হাতে নিয়ে শুরু করবেন এবং শেষ করবেন তার মধ্যে কয়েক সপ্তাহ থাকতে পারে এবং সেই সময়ে, আপনি ভুলে যেতে পারেন কেন আপনি কোড লেখার সময় কিছু সিদ্ধান্ত নিয়েছিলেন। কিছু বিকাশকারী আসলে আপনি কোড লেখার আগে আপনার মন্তব্য লেখার পরামর্শ দেন এবং এটি আপনাকে গাইড করতে দেয়।</p>
                                            </div>
                                            <div>
                                                <h2 className='mt-10 font-mono lg:text-2xl md:2xl text-2xl text-start font-bold text-black mb-3'>কোড মন্তব্য লেখার সময় যে বিষয়গুলো এড়িয়ে চলতে হবে</h2>
                                                <p className='mt-5  text-justify  text-gray-800 font-serif  text-[19px]'>কোড মন্তব্য সম্পর্কে মনে রাখা সবচেয়ে গুরুত্বপূর্ণ বিষয়গুলির মধ্যে একটি: ভুল তথ্য হল কোন তথ্যের চেয়ে খারাপ। মন্তব্য বিভ্রান্তি দূর করা উচিত, এটির কারণ নয়। <br /> আপনার মন্তব্যের সীমাবদ্ধতা বোঝা উচিত। একাধিক উৎস ফাইল বা সংগ্রহস্থল জুড়ে প্রবাহ ব্যাখ্যা করার চেষ্টা করা; মন্তব্য ব্যবহার করে সহায়কের চেয়ে বেশি বিভ্রান্তিকর হতে পারে। এই প্রবাহগুলি ব্যাখ্যা করার আরও ভাল উপায় রয়েছে, যেমনটি আমরা পরে বর্ণনা করব। <br /> কোডে মন্তব্য সবসময় আপ টু ডেট রাখা উচিত। তারা সঠিকভাবে প্রশ্নে কোডের বর্তমান অবস্থা প্রতিফলিত করা উচিত. আপনি যদি একটি প্রকল্পের কোডের একটি অংশে পরিবর্তন করেন, তাহলে আপনাকে সেই অনুযায়ী মন্তব্যটি আপডেট করতে হবে।</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-6 text-xl font-bold text-start mb-2 text-gray-800'>"টু-ডু" মন্তব্য করবেন না</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>এর জন্য ওয়ার্ক ম্যানেজমেন্ট সিস্টেম ব্যবহার করুন। আপনি যদি একটি TODO চাপিয়ে থাকেন, তাহলে আপনার পরিবর্তে একটি সমস্যা তৈরি করা উচিত। অন্যথায়, আপনি কেবল প্রযুক্তিগত ঋণ তৈরি করছেন।</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>ভুল জায়গায় মন্তব্য লিখবেন না।</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'> কোডের মধ্যে একটি যৌক্তিক অবস্থানে আপনার কোড মন্তব্য যোগ করুন, এবং আপনার অনুশীলন সামঞ্জস্যপূর্ণ রাখুন। এটি আপনার প্রয়োজন হলে মন্তব্যগুলি খুঁজে পাওয়া সহজ করে তোলে৷</p>
                                            </div>
                                            <div>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>কোড আউট মন্তব্য করবেন না</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'> কোড মন্তব্য করার পরিবর্তে, আপনার কোড পরিবর্তনগুলি ট্র্যাক করতে গিট-এর মতো সংস্করণ নিয়ন্ত্রণ ব্যবস্থা ব্যবহার করা ভাল।</p>
                                            </div>
                                            <div className='mb-16'>
                                                <h1 className='mt-3 text-xl font-bold text-start mb-2 text-gray-800'>অতিরিক্ত মন্তব্য করবেন না।</h1>
                                                <p className='text-justify  text-gray-800 font-serif  text-[19px]'>অনেক বেশি মন্তব্য কোড পড়া এবং বোঝা কঠিন করে তুলতে পারে। শুধুমাত্র প্রয়োজন হলেই মন্তব্য যোগ করুন, কোডের প্রতিটি লাইনে নয়। অপ্রয়োজনীয় মন্তব্য এড়িয়ে চলুন</p>
                                            </div>
                                        </div>
                                }

                            </div>


                        </div>


                        <ReactToPrint trigger={() => <button className='print:hidden ml-1 hover:scale-105 mt-28 mb-16 px-6 py-2 bg-green-600 text-white'>
                            <div className='text-[16px] text-white flex justify-start items-center gap-x-1'>
                                <BsFileEarmarkPdf size={25} className='text-white'></BsFileEarmarkPdf>
                                {
                                    language === 'english' ?
                                        <p>Download PDF</p>
                                        :
                                        <p>ডাউনলোড পিডিএফ</p>
                                }
                            </div>
                        </button>} content={() => ref.current}>
                        </ReactToPrint>



                        {
                            language === 'english' ?
                                <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>Share This Post</h1>
                                :
                                <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>পোস্টটি শেয়ার করুন</h1>
                        }
                        <div className='print:hidden flex justify-start items-center'>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Facebook'>
                                <FacebookShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on Facebook'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <FacebookIcon size={38} round={true} />
                                </FacebookShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Twitter'>
                                <TwitterShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on Twitter'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <TwitterIcon size={38} round={true} />
                                </TwitterShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on LinkedIn'>
                                <LinkedinShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on LinkedIn'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <LinkedinIcon size={38} round={true} />
                                </LinkedinShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on WhatsApp'>
                                <WhatsappShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on WhatsApp'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <WhatsappIcon size={38} round={true} />
                                </WhatsappShareButton>
                            </div>
                        </div>


                    </div>









                </div>







                <div className='print:hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1 '>
                    <div className='lg:right-auto lg:fixed lg:top-[160px] lg:mr-10 relative'>
                        <div className={`bg-gray-700 rounded-sm px-3 pt-2 pb-3`}>
                            <p className='text-white text-center text-lg -mt-1 px-6 py-1'>Read More Blogs... </p>

                            <div>

                                <Link to='/blog1'>
                                    <div className=' hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={npm} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white  md:text-lg lg:text-[16px] text-md '>7 Most Popular Animation Libraries For React</p>
                                    </div>
                                </Link>


                                <Link to='/blog2'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={npm1} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white '>Worst npm Packages you should not use</p>
                                    </div>
                                </Link>

                                <Link to='/blog4'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={visa} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white  md:text-lg lg:text-[16px]  text-md '>EveryThing You Should Know about Student Visa</p>
                                    </div>
                                </Link>

                                <Link to='/blog3'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={studyAbroad} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white  md:text-lg lg:text-[16px]  text-md'>Why Study Abroad? Stories From International Students</p>
                                    </div>
                                </Link>





                                {/* <div className=' -mt-12 lg:w-[300px] md:w-[680px] sm:w-[350px] w-[350px]  '>
                                    <Swiper
                                        pagination={{
                                            clickable: true
                                        }}
                                        modules={[Pagination, Autoplay, Navigation]}
                                        autoplay={{ delay: 2000 }}
                                        className="mySwiper"
                                    >

                                        <SwiperSlide className=''>
                                            <div>

                                                <Link to='/blog4'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={visa} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>EveryThing You Should Know about Student Visa</p>
                                                    </div>
                                                </Link>

                                                <Link to='/blog3'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={studyAbroad} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md'>Why Study Abroad? Stories From International Students</p>
                                                    </div>
                                                </Link>

                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide className=''>
                                            <div>
                                                <Link to='/blog1'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={npm} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>7 Most Popular Animation Libraries For React</p>
                                                    </div>
                                                </Link>

                                                <Link to='/blog5'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={program} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>4 Reasons Why Year Gap In Study Isn't End of life</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>

                                    </Swiper>
                                </div> */}


                            </div>



                        </div>
                    </div>
                </div>




            </div>


        </div>
    );
};

export default Blog6Details;